export default __webpack_public_path__ + "static/media/plague@2x.626362a1.webp";